module.exports = __webpack_public_path__ + "img/group_lightning.66e16c5d.svg";